import { Tag } from "common/components/ui/Tag";

import SectionContainer from "./SectionContainer";

export default function Skills({
  skills,
}: {
  skills: { name: string; endorsements: number }[];
}) {
  return (
    <SectionContainer
      title="Skills"
      extraComponent={<Tag variant="primary-black">{skills.length}</Tag>}
    >
      <div className="grid grid-cols-1 gap-2.5 lg:grid-cols-3">
        {skills.map(({ name, endorsements }) => (
          <div
            key={name}
            className="flex h-10 items-center justify-between rounded-3xl border border-black-200 pl-4 pr-2"
          >
            <span className="text-sm text-black-600">{name}</span>
            {endorsements && <Tag variant="quaternary">{endorsements}</Tag>}
          </div>
        ))}
      </div>
    </SectionContainer>
  );
}
